import InProgressIcon from '~/images/completed-projects-map/in-progress.svg';
import WaterDropsIcon from '~/images/completed-projects-map/water-drops-icon.svg';
import pluralize from 'pluralize';
import { observer } from 'mobx-react';

const NoImpactCta = observer(({ currentUser, inProgressDonationCount }) => (
  <div className='no-impact-cta theme-design-system-v1 flex flex-row bg-grey-10 absolute border border-grey-70 border-l-0 border-b-0 border-r-0 md-border-t-0 py-0 rounded w-full'>
    <div className='flex flex-col items-center justify-center p-8 text-cw-black'>
      {inProgressDonationCount == 0 && (
        <>
          <img src={WaterDropsIcon} />
          <h4 className='heading-s pt-3'>100% funds clean water</h4>
          <p
            className='body-s pt-3 text-center'
            dangerouslySetInnerHTML={{
              __html: `It only takes ${
                currentUser.country == 'us' ? '$40' : '£30'
              } to bring 1 person reliable access to&nbsp;clean water.`,
            }}
          />
          <a
            className='button button--cw-yellow text-cw-black mt-5'
            href='/donate'
          >
            Give Today
          </a>
        </>
      )}
      {inProgressDonationCount > 0 && (
        <>
          <img src={InProgressIcon} />
          <h4
            className='body-m pt-3 text-center'
            dangerouslySetInnerHTML={{
              __html: `You have ${inProgressDonationCount} ${pluralize(
                'donations',
                inProgressDonationCount
              )} that ${
                inProgressDonationCount == 1 ? 'is' : 'are'
              } being put&nbsp;to&nbsp;work`,
            }}
          />
          <p
            className='body-s pt-3 text-center'
            dangerouslySetInnerHTML={{
              __html:
                'Once construction is complete, we&rsquo;ll show you the community you helped&nbsp;support.',
            }}
          />
        </>
      )}
    </div>
  </div>
));

export default NoImpactCta;
